import { dismissToast } from '@adv-frontend/toast';

export function createToastQueue({ maxCount = 2 }: { maxCount?: number } = {}) {
    const queue: string[] = [];

    return function wrapToast(id: string | undefined) {
        if (typeof id === 'undefined') {
            return;
        }

        queue.push(id);

        if (queue.length >= maxCount) {
            const idsToHidden = queue.splice(0, queue.length - maxCount);

            idsToHidden.forEach(dismissToast);
        }
    };
}
